"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllDayEventClamper = void 0;
const lodash_1 = require("lodash");
const period_1 = require("./period");
// 終日イベントの配列を指定した日付範囲でclampする
// Period#andのおかげで非常にシンプル
class AllDayEventClamper {
    static clampAll(events, start, end) {
        return (0, lodash_1.compact)(events.map((ev) => this.clamp(ev, start, end)));
    }
    static clamp(allDayEvent, start, end) {
        const clampedPeriod = allDayEvent.event.period.and(new period_1.Period(start, end));
        if ((0, lodash_1.isNull)(clampedPeriod)) {
            return null;
        }
        return {
            event: Object.assign(Object.assign({}, allDayEvent.event), {
                period: clampedPeriod
            }),
            rowIndex: allDayEvent.rowIndex
        };
    }
}
exports.AllDayEventClamper = AllDayEventClamper;
//# sourceMappingURL=allDayEventClamper.js.map